module.exports = __webpack_public_path__ + "img/TPV-L1-4-Pagina6 A-1.dbc59b1b.png";